import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BookmarkProblemListRouterService {
  private state: string = null;

  setState(state: string): void {
    this.state = state;
  }

  getState(): string {
    return this.state;
  }

  clearState(): void {
    this.state = null;
  }
}
